module.exports = __webpack_public_path__ + "static/media/ChatBotIcon.281b2b89.svg";